import { Component } from '@angular/core';

@Component({
  selector: 'icon-save',
  templateUrl: './icon-save.component.html',
  styleUrls: ['./icon-save.component.sass']
})
export class IconSaveComponent {}
